<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-discipline-disciplinary-category-dialog-create
          v-if="$hasPermissionTo(['create disciplinary categories'])"
          @created="loadData"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Disciplinary Category's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in disciplinary category here"
          append-icon="search"
          label="Search Disciplinary Categories"
          hide-no-data
          hide-selected
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="filteredDisciplinaryCategories"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.action="{ item }">
        <span v-if="statusFilter">
          <setup-discipline-disciplinary-category-dialog-edit
            v-if="$hasPermissionTo(['update disciplinary categories'])"
            :disciplinary-category="item"
            @updated="loadData"
          />
          <span class="mx-1" />
          <setup-discipline-disciplinary-category-dialog-delete
            v-if="$hasPermissionTo(['delete disciplinary categories'])"
            :disciplinary-category="item"
            @deleted="loadData"
          />
        </span>
        <span v-else>
          <setup-discipline-disciplinary-category-dialog-restore
            v-if="$hasPermissionTo(['restore disciplinary categories'])"
            :disciplinary-category="item"
            @restored="loadData"
          />
        </span>
      </template> 
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupDisciplineDisciplinaryCategoryDialogCreate: () => import('@/components/hris/setup/disciplines/disciplinary-category/DialogCreate'),
      SetupDisciplineDisciplinaryCategoryDialogDelete: () => import('@/components/hris/setup/disciplines/disciplinary-category/DialogDelete'),
      SetupDisciplineDisciplinaryCategoryDialogRestore: () => import('@/components/hris/setup/disciplines/disciplinary-category/DialogRestore'),
      SetupDisciplineDisciplinaryCategoryDialogEdit: () => import('@/components/hris/setup/disciplines/disciplinary-category/DialogEdit'),
    },
    data () {
      return {
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        headers: [
          {
            text: 'Disciplinary Category',
            align: 'left',
            value: 'name',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        tableLoading: true,
        disciplinaryCategories: [],
        trashedDisciplinaryCategories: [],
      }
    },
    computed: {
      filteredDisciplinaryCategories () {
        return this.statusFilter ? this.disciplinaryCategories : this.trashedDisciplinaryCategories
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        Promise.all([
          this.$api.disciplinaryCategories().list(),
          this.$api.disciplinaryCategories().listTrashed(),
        ]).then(([disciplinaryCategory, trashedDisciplinaryCategory]) => {
          this.disciplinaryCategories = disciplinaryCategory.data
          this.trashedDisciplinaryCategories = trashedDisciplinaryCategory.data

          this.tableLoading = false
        })
      },
    },
  }
</script>
